import ContactUs from "../components/ContactUs";
import StayInLoop from "../components/StayInLoop";
import CardSwapSectionComponent from "../components/CardsSwapSection";
import { CardSwapImg, CardSwapImg1, CardSwapImg2, CardSwapImg3, ProductHeroVideo } from "../constant";
import WeAreIED from "../components/WeAreIED";
import CustomersAndUsers from "../components/CustomerAndUser";
import HeroAboutVideo from "../components/HeroAboutVideo";
import CookieConsent from "../components/CookiesContent";
import CustomSlider from "../components/FeedbackSlider";
import TeamCarousel from "../components/About/Team";
import AboutHero from "../components/About/AboutHero";


const cardSwapData = [
  {
    number: '01',
    title: 'EHS, ESG Intelligence',
    description:
      'Centralize compliance, emissions, audits, incidents, carbon accounting, and sustainability reporting in one enterprise platform.',
    image: CardSwapImg1,
  },
  {
    number: '02',
    title: 'Connected Operations',
    description:
      'Monitor machines, assets, utilities, and industrial operations in real time using connected sensors and operational intelligence.',
    image: CardSwapImg2,
  },
  {
    number: '03',
    title: 'Enterprise AI',
    description:
      'Enable Generative AI, Agentic AI, RAG-based knowledge systems, predictive analytics, and intelligent automation across enterprise workflows.',
    image: CardSwapImg3,
  }];

const testimonialsData = [
  {
    quote:
      "NetZero enabled us to streamline ESG reporting and improve sustainability visibility across operations.",
    author: "General Manager, EHS",
    note: "An Integrated Energy Enterprise",
  },
  {
    quote:
      "The platform transformed our EHS processes with real-time monitoring, analytics, and actionable insights.",
    author: "Project Safety Head",
    note: "Major Oil & Gas Operator",
  },
  {
    quote:
      "Aurora helped us connect critical industrial assets and improve operational efficiency significantly.",
    author: "Project Manager",
    note: "An Integrated Oil & Gas Operator",
  },
  {
    quote:
      "We now manage compliance, audits, and sustainability reporting from a single intelligent platform.",
    author: "Head, Digital Transformation",
    note: "A Large Mining Company",
  },
  {
    quote:
      "Implementation was seamless, and the solution scaled perfectly across our enterprise operations.",
    author: "Chief Manager – Projects",
    note: "A Large Refining Company",
  },
  {
    quote:
      "The risk engagement simplified complex reporting requirements while improving data accuracy and governance.",
    author: "Chief Risk Officer",
    note: "A Large Power Generation Company",
  },
  {
    quote:
      "Connected operational intelligence and sustainability insights helped us achieve measurable business outcomes.",
    author: "Head – Projects",
    note: "One of the Largest EPC Players",
  },
  {
    quote:
      "Real-time visibility into risks, emissions, and compliance improved our overall operational performance.",
    author: "Head – Sustainability",
    note: "A Large Defence Manufacturer",
  },
  {
    quote:
      "A modern digital transformation platform that delivers measurable impact across EHS, ESG, and operations.",
    author: "Nodal Officer, Digital Initiatives",
    note: "One of the Largest Mining Operators",
  },
];

export default function About() {
  return (
    <>
      <AboutHero />
      <HeroAboutVideo isNetzero={true} isProduct={false} />
      <CardSwapSectionComponent
        data={cardSwapData}
        title={`Achieve Business Outcomes`}
        subTitle={`We help enterprises in their journey to zero through digital transformation. We deliver EHS & ESG software solutions for a cleaner and greener planet. Our solution delivers sustainable outcomes.`}
      />
      <WeAreIED />
      <CustomersAndUsers />
      <CustomSlider testimonials={testimonialsData} />
      <TeamCarousel />
      <ContactUs />
      <StayInLoop />
      <CookieConsent />
    </>
  );
}
